import React, { Component } from 'react'
import { Box } from 'reactjs-admin-lte'
import { FormControl, Button, ButtonToolbar } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

var NotificationSystem = require('react-notification-system');

class FixCommissionConfig extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      data:[
          {description:'รื้อ',percent:'0.5',remark:''},
          {description:'เคาะ',percent:'2.5',remark:''},
          {description:'โป้ว',percent:'2.0',remark:''},
          {description:'เตรียมพื้น',percent:'2.0',remark:''},
          {description:'ผสมสี',percent:'1.0',remark:''},
          {description:'พ่นสี',percent:'2.0',remark:''},
          {description:'ประกอบ',percent:'2.0',remark:''},
          {description:'ขัดสี',percent:'1.75',remark:''},
          {description:'ล้างทำความสะอาด',percent:'0.75',remark:''},
          {description:'ติดประดาษ',percent:'',remark:''}
        ]
    }  
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps){

  }

  onTextChange(index,key,e) {
    let {data} = this.state
    data[index][key] = e.target.value
    this.setState({data:data})
  }

  renderRowData() {
    let {data} = this.state
    return(
        data.map((item,index)=>
            <tr key={index}>
                <td style={{verticalAlign:'middle'}}>{index+1}. {item.description}</td>
                <td style={{verticalAlign:'middle'}} className='text-center'>
                    <FormControl
                        size={3}
                        className='text-center'
                        value={item.percent}
                        onChange={this.onTextChange.bind(this,index,'percent')}
                    />
                </td>
                <td className='text-center'>
                    <FormControl
                        componentClass='textarea'
                        rows={2}
                        value={item.remark}
                        onChange={this.onTextChange.bind(this,index,'remark')}
                    />
                </td>
            </tr>    
        )
    )
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid table-tool' style={{minWidth:'1024px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{ width: '200px', minWidth: '200px' }}>ขั้นตอน</th>
              <th className='text-center' style={{ width: '80px', minWidth: '80px' }}>เปอร์เซ็นใหม่</th>
              <th className='text-center' style={{ width: '200px', minWidth: '200px' }}>หมายเหตุ</th>
            </tr>  
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return (
      <div>    
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>ตั้งค่านายหน้างานซ่อม</Box.Title>
            <Box.Tools>
                
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            {this.renderTable()}
          </Box.Body>    
          <Box.Footer>
            <ButtonToolbar className='pull-right'>  
              <Button bsStyle='primary'><FontAwesome name='save' />&nbsp;บันทึก</Button>    
            </ButtonToolbar>  
          </Box.Footer>          
        </Box>
        <NotificationSystem ref="notificationSystem" /> 
      </div>    
    )
  }
}

FixCommissionConfig.defaultProps = {
  
}

export default FixCommissionConfig;


// WEBPACK FOOTER //
// ./src/view/workdoc/fixlevel/FixCommissionConfig.js